import { render, staticRenderFns } from "./ProcessWorkPermitReview.vue?vue&type=template&id=811be8ca"
import script from "./js/ProcessWorkPermitReview.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermitReview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports